import React, { createContext, useContext, useState, useEffect } from 'react';

// Create context
const CompanyContext = createContext();

export const CompanyProvider = ({ children }) => {
  const [companyDet, setCompanyDet] = useState(null);
  const [companyId, setCompanyId] = useState(null);

  const setCompany = (data) => {
    setCompanyDet(data);
    setCompanyId(data?.company_id);

    sessionStorage.setItem('companyDetails', JSON.stringify(data));
    sessionStorage.setItem('companyId', data?.company_id);
    sessionStorage.setItem('x_company_domain', data?.x_company_domain);
  };

  return (
    <CompanyContext.Provider value={{ companyId, companyTheme: companyDet, setCompany }}>
      {children}
    </CompanyContext.Provider>
  );
};


// Custom hook to access context
export const useCompanyTheme = () => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error('useCompanyTheme must be used within a CompanyProvider');
  }
  return context;
};
